export class AppSetting {
	id: string;
	name: string;
	value: any;
	type: string;
	mask: boolean

	valueAsString(): string {
		return this.value as string;
	}

	valueAsNumber(): number {
		return parseFloat(this.value);
	}

	valueAsDate(): Date {
		return new Date(this.value);
	}

	valueAsBoolean(): boolean {
		return this.value === true || this.value?.toString()?.toLowerCase() === "true";
	}
}